import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';

const EMPTY = { department: '', city: '', address: '', contact_name: '', phone: '' };
const FIELD_NAMES = { department: 'departamento de recogida', city: 'ciudad', address: 'dirección (mínimo 5 caracteres)', contact_name: 'persona de contacto', phone: 'celular (10 dígitos, empieza por 3)' };
const FIELDS = [['city', 'Ciudad'], ['address', 'Dirección de recogida'], ['contact_name', 'Persona de contacto'], ['phone', 'Celular (10 dígitos)']];

// Modalidad del vendedor: envía él mismo (Opción 1) o AutoMarket recoge y despacha (Opción 2).
export const SellerLogisticsMode = ({ departments }) => {
  const [st, setSt] = useState(null);
  const [mode, setMode] = useState('seller');
  const [pickup, setPickup] = useState(EMPTY);
  const [shipments, setShipments] = useState({ items: [], labels: {} });

  useEffect(() => {
    api.get('/sellers/me/logistics').then(({ data }) => {
      setSt(data); setMode(data.logistics.mode); setPickup({ ...EMPTY, ...(data.logistics.pickup || {}) });
    }).catch(() => {});
    api.get('/sellers/me/shipments').then(({ data }) => setShipments(data)).catch(() => {});
  }, []);
  if (!st || (!st.automarket_available && st.logistics.mode !== 'automarket')) return null;

  const save = async () => {
    try {
      const { data } = await api.put('/sellers/me/logistics', { mode, pickup: mode === 'automarket' ? pickup : (st.logistics.pickup || null) });
      setSt({ ...st, logistics: data.logistics });
      toast.success('Modalidad de envío guardada');
    } catch (e) {
      const d = e.response?.data?.detail;
      const field = Array.isArray(d) ? FIELD_NAMES[d[0]?.loc?.[d[0].loc.length - 1]] : null;
      toast.error(d?.message || (field ? `Revisa: ${field}` : (Array.isArray(d) ? String(d[0]?.msg || '').replace(/^Value error,\s*/, '') : 'No se pudo guardar')));
    }
  };

  return (
    <div className="mt-6 border border-slate-200 bg-white p-5" data-testid="seller-logistics-mode">
      <div className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">¿Quién gestiona tus envíos?</div>
      <div className="mt-3 space-y-2 text-sm">
        <label className="flex items-start gap-2"><input type="radio" checked={mode === 'seller'} onChange={() => setMode('seller')} data-testid="seller-mode-seller" />
          <span><b>Yo envío mis pedidos</b> con mis tarifas por zona (configuración de abajo).</span></label>
        <label className="flex items-start gap-2"><input type="radio" checked={mode === 'automarket'} onChange={() => setMode('automarket')} data-testid="seller-mode-automarket" />
          <span><b>AutoMarket recoge y entrega</b>: el comprador paga el flete con la tarifa de AutoMarket y tú asumes el cargo logístico que se descuenta de tu desembolso. Requiere peso, medidas y valor declarado en todos tus productos activos.</span></label>
      </div>
      {mode === 'automarket' && (
        <div className="mt-3 grid grid-cols-1 gap-2 md:grid-cols-2" data-testid="seller-pickup-form">
          <select value={pickup.department} onChange={(e) => setPickup({ ...pickup, department: e.target.value })}
            className="h-9 border border-slate-300 bg-white px-2 text-sm" data-testid="seller-pickup-department">
            <option value="">Departamento de recogida…</option>
            {departments.map((d) => <option key={d} value={d}>{d}</option>)}
          </select>
          {FIELDS.map(([k, l]) => (
            <label key={k} className="text-xs font-semibold text-slate-700">{l}
              <Input value={pickup[k]} onChange={(e) => setPickup({ ...pickup, [k]: e.target.value })}
                className="rounded-none h-9 mt-1" data-testid={`seller-pickup-${k}`} />
            </label>
          ))}
        </div>
      )}
      <Button onClick={save} className="mt-3 rounded-none bg-slate-900" data-testid="seller-mode-save">Guardar modalidad</Button>
      {st.logistics.mode === 'automarket' && (
        <p className="mt-2 text-xs text-slate-500" data-testid="seller-mode-note">Con AutoMarket gestionando tus envíos, tus tarifas por zona de abajo no se aplican; solo se usan si vuelves a «Yo envío mis pedidos».</p>
      )}
      {!!shipments.items.length && (
        <div className="mt-5" data-testid="seller-shipments">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">Despachos de AutoMarket</div>
          <ul className="mt-2 divide-y divide-slate-100 text-sm">
            {shipments.items.map((x) => (
              <li key={x.shipment_id} className="flex justify-between py-1.5" data-testid={`seller-shipment-${x.shipment_id}`}>
                <span className="font-mono text-xs">{x.order_id}</span>
                <span>{shipments.labels[x.status]}{x.tracking_code ? ` · ${x.carrier} ${x.tracking_code}` : ''}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
